import { Col, Grid, Row, Space, Typography } from "@payping/web-components";
import React from "react";
import { useAsync, useAsyncRetry } from "react-use";
import { getCashOutOverview, getCashOutRequests } from "@payping/redux/actions";

import { useAppDispatch, useAppSelector } from "@/utils/redux";
import UnknownAlert from "@/pages/Settlement/Overview/unknownAlert";
import { FiltersType, GridifyConditionEnum, createQuery } from "@payping/utils/api";
import { RequestStatusEnum, requestPublicApis } from "@payping/api";
import { useAppTranslation } from "@/utils";
import ChangeAdvancedSettlement from "./changeAdvancedSettlement";
import DataCard from "./dataCard";
import LatelyRequestList from "./latelyRequestList";
import WebServices from "./webServices";

const Overview: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useAppTranslation();
  const { requestList } = useAppSelector((state) => state.cashOuts);
  const { loading } = useAsync(() => dispatch(getCashOutOverview()));
  const { md } = Grid.useBreakpoint();

  const { retry: retryList } = useAsyncRetry(async () => {
    const filter: FiltersType = [
      {
        status: [
          GridifyConditionEnum.Equal,
          [RequestStatusEnum.Draft, RequestStatusEnum.Final, RequestStatusEnum.Failed, RequestStatusEnum.Unknown],
          { parenthesis: true },
        ],
      },
    ];
    await dispatch(getCashOutRequests(0, 5, undefined, createQuery(filter)));
  }, [requestList?.count]);

  const { value, retry: retryStatus } = useAsyncRetry(async () => {
    const filter: FiltersType = [
      {
        status: [GridifyConditionEnum.Equal, [RequestStatusEnum.Unknown], { parenthesis: true }],
      },
    ];
    return requestPublicApis.requestsListWithQueryGet(1, 1, undefined, createQuery(filter));
  }, []);

  return (
    <Row gutter={[16, 16]} className={"tw-w-full"}>
      <Col xs={24} xl={18}>
        <Space direction={"vertical"} size={"large"} className={"tw-w-full"}>
          {md && <Typography.Title level={4}>{t("overview.settlementCard.title")}</Typography.Title>}
          <UnknownAlert value={value} retryStatus={retryStatus} retryList={retryList} />
          <ChangeAdvancedSettlement />
          <DataCard unknownStatus={value} loading={loading} />
          <LatelyRequestList retryList={retryList} />
        </Space>
      </Col>
      <Col xs={24} xl={6}>
        <WebServices />
      </Col>
    </Row>
  );
};

export default Overview;
